import { render, staticRenderFns } from "./ExFormatEdit.vue?vue&type=template&id=47e1e71c&scoped=true"
import script from "./ExFormatEdit.vue?vue&type=script&lang=js"
export * from "./ExFormatEdit.vue?vue&type=script&lang=js"
import style0 from "./ExFormatEdit.vue?vue&type=style&index=0&id=47e1e71c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e1e71c",
  null
  
)

export default component.exports